/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectorType {
    SOURCE = 'SOURCE',
    SINK = 'SINK'
}

export function ConnectorTypeFromJSON(json: any): ConnectorType {
    return ConnectorTypeFromJSONTyped(json, false);
}

export function ConnectorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectorType {
    return json as ConnectorType;
}

export function ConnectorTypeToJSON(value?: ConnectorType | null): any {
    return value as any;
}

